export enum TermType {
  general = 'allmänna villkor',
  integrity = 'integritetspolicy',
  chat = 'chat',
  bookkeepForMe = 'bookkeep-for-me',
  adviceEmail = 'advice-email',
  advicePhone = 'advice-phone',
  bookend = 'bookend',
  bookendAb = 'bookend-ab',
}

export interface GetTermsResponse {
  id: string;
  termText: string;
  termType: TermType;
}

export interface AcceptTermsRequest {
  companyId: string;
  termType: TermType;
}
